import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { GLSLocation } from "../../domain/models/gls-location";
import { PublicLocationsRepository } from "../../repositories/public-location.repository";

@Injectable({ providedIn: 'root' })
export class GetPublicLocationsByJobIdUsecase
  implements UseCase<string, GLSLocation[]>
{
  constructor(
    private readonly publicLocationRepository: PublicLocationsRepository
  ) {}

  execute(request: string): Observable<GLSLocation[]> {
    return this.publicLocationRepository.getPublicLocationsByJobId(
      request
    );
  }
}